import Vue from 'vue'
import Vuex from 'vuex'

import getStaffName from '@/utils/getStaffName.js';
//import getCustomerName from '@/utils/getCustomerName.js';
import getAdTitle from '@/utils/getAdTitle.js'

import WebSoc from '@/utils/WebSoc.js';
import MD5 from '@/utils/MD5.js';
import { format } from 'date-fns'
import mapDB from '@/utils/mapDB.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: false,
    client: {},
    name: '',
    customerCount: 0,
    userCount: 0,
    client_id: '',
    siteTitle: '',
    dashBanner: '',
    currentOffers: false,
    username: '',
    customerNames: [],
    editingAd: false,
    authReset: false,
    customerNames: {},
    component: '',
    item: false,
    showSpinner: false,
    showCurrentOffers: false,
    DB: {
      users: [],
      customers: [],
      ads: [],
      campaigns: [],
      referrals: [],
      messages: [],
      wallets: [],
      cards: [],
      pages: []
    },
    progress: 0,
    customers: [],
    quills: [],
    chartUpdate: 0
  },
  getters: {
    wallets: state => {
      var DB = state.DB;
      //console.log('getters.wallets',DB.wallets.length);
      return DB.wallets.map(wallet => {
        wallet.show = true;
        wallet.components = wallet.components || [];
        wallet.cards = wallet.cards.map(c => { var Card = DB.cards.find(card => card._id == c._id); if ( !Card ) { 
          console.log('remove? !CARD',c);
          WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pull: { cards: c } }},() => console.log('removed',c._id));
         } return Card ? Card : ( c._id ? c : false ) }); //.filter(c => c); //.filter(m => m);
         //console.log('wallet',wallet.title,wallet.cards.length);
        return wallet;
      })
    },
    cards: state => {
      
      var DB = state.DB;
      //console.log('getters.cards',DB.cards.length);
      var wallets = DB.wallets;
      var exists = {};
          wallets.forEach(wallet => {
            exists[wallet._id] = {};
            wallet.cards.forEach(card => exists[wallet._id][card._id] = wallet)
          });
      return DB.cards.filter(c => !c.removed).map(card => {
        card.show = true;
        card.components = card.components || [];
        //console.log('exists',exists);
        card.wallets = DB.wallets.filter(wallet => exists[wallet._id][card._id]);
        return card;
      });
    }
  },
  mutations: {
    saveQuill ( state, quill ) {
      state.quills.push(quill);
    },
    setValue: ( state, data ) => { console.log('setValue',Object.keys(data)); Object.keys(data).forEach(key => state[key] = data[key]) },
    setDB ( state, data ) {
      
      data.DB = mapDB(data.DB);
      var DB = state.DB[data.DB];
      if ( !DB ) return console.log('!DB',DB,state.DB);

      state.DB[data.DB] = data.items;

    },
    setCustomerName ( state, data ) {
      var { item, name, complete } = data;
      item.name = name;
      console.log('setCustomerName',name);
      typeof complete == 'function' && complete(name);
    },
    addDB ( state, data ) {
      data.DB = mapDB(data.DB);
      var DB = state.DB[data.DB];
      if ( !DB ) return console.log(!DB,state.DB);
      //console.log('addDB',data);
      switch ( data.DB ) {
        case 'pages': 
          //var before = data.items.filter(p => ['home','join'].indexOf(p.face) > -1).length;
          //data.items = data.items.filter(page => ['home','join'].indexOf(page.face) == -1);
          //var after = data.items.filter(p => ['home','join'].indexOf(p.face) > -1).length;
          //console.log({
          //  before,
          // after
          //});
        case 'campaigns':

          break;
        case 'customers':
            data.items.forEach(i => i.components = []);
          break;
        case 'users':

          break;
        case 'wallets':   
        case 'cards':
          data.items.forEach(i => { 
            i.show = true;
            i.selected = false;
            i.components = [] 
          });
          break;
      }
      //data.items.length == 0 && console.log('splice item';)
      //data.items.length == 0 && DB.splice(0,DB.length);

      data.items.forEach((item,i,arr) => {
        var current = DB.find(i => i._id == item._id);
        if ( current ) { return /* console.log('current',item); */ }
        data.items.length == 1 ? DB.splice(0,0,item) : DB.push(item);
      });
      data.DB == 'campaigns' && !data.top && DB.sort((a,b) => a.created < b.created ? 1 : - 1)
    },
    removeDB ( state, data ) {
      data.DB = mapDB(data.DB);
      console.log('removeDB',data.DB,data._id);
      var DB = state.DB[data.DB];
      if ( !DB ) return console.log('!DB removeDB',data);
      var item = DB[data._id];
      if ( !item ) item = DB.find(i => i._id == data._id);
      if ( !item ) return console.log('!item',{
        DB,
        data
      });
      var index = DB.indexOf(item)
      index > -1 && DB.splice(index,1);
      delete DB[data._id]
    },
    resetDB ( state, data ) {
      //console.log('**** resetDB',data);
      data.DB = mapDB(data.DB);
      state.DB[data.DB] = [];
    },
    removeCampaign ( state, campaign ) {

    },
    setObjValue ( state, data ) {
      //console.log('setObjValue',data);
      data.obj[data.k] = data.v
    },
    setKeyValue ( state, data ) {
      //console.log('setKeyValue',data);
      state[data.k] = data.v
    },
    clearProgress ( state ) {
      clearInterval(state.interval);
      state.progress = 0;
    },
    addPage ( state, data ) {
      console.log('mutate addPage data.campaign',data.campaign);
      console.log('mutate addPage data.addPage',data.addPage);
    },
    updateAd ( state, update ) {
      var ad = state.editingAd;
      if ( ad.ad_id == update.ad_id && ad.campaign_id == update.campaign_id ) {
        Object.keys(update.update).forEach(key => {
          ad[key] = update.update[key];
        })
      }
      WebSoc.SEND('update',{ DB: 'jb-ads', _id: update.ad_id, update: { $set: update.update }},() => {
        console.log('updatedAd',{ DB: 'jb-ads', _id: update.ad_id, update: { $set: update.update } });
      });
    },
    updateDB ( state, data ) {
      
      data.DB = mapDB(data.DB);
      console.log('*** Update DB ***',data);
      data.DB == 'wallets' && console.log('updateDB',data.DB,data._id,data);

      var DB = state.DB[data.DB];
      if ( !DB ) return
      var item = DB[data._id];
      if ( !item ) item = DB.find(i => i._id == data._id);   

      if ( !item && data.DB == 'campaigns' ) {
        if ( data._id == state.currentOffers._id ) {
          //console.log('state.currentOffers',state.currentOffers);
          item = state.currentOffers;
        }
      }
      
      if ( !item ) { 
        console.log('!item',data.DB,data._id);
        return;
      }

      //console.log('data.$update',data.$update);

      Object.keys(data.$update).forEach(key => {

          var obj = item;
          key.split('.').forEach((Key,i,arr) => { 
            if ( !obj ) return console.log('stop',i,obj,key.split('.')); 
            //console.log('Key',Key);
            if ( i == arr.length - 1 ) { 
              //console.log('arr.length-1',arr);
              if ( !isNaN(Key) && Array.isArray(obj) ) { 
                //console.log('isArray',obj);
                if ( data.DB == 'campaigns' && arr[arr.length-2] == 'pages' ) {
                  var newPage = data.$update[key];
                  if ( obj.find(p => p.code == newPage.code) ) return console.log('update to page',newPage);
                }
                if ( data.DB == 'wallets' && arr[arr.length-2] == 'cards' ) {

                  if ( !isNaN(Key) ) {
                    console.log('reset wallets / cards 216');


                    var index = parseInt(Key);
                    if ( index == obj.length ) { 
                        
                        obj.push(data.$update[key]);

                        //var cards = state.DB.cards;
                        //var wallets = state.DB.wallets;
                        state.DB.cards = state.DB.cards.map(c => c);
                        state.DB.wallets = state.DB.wallets.map(w => w);
                        /*
                        setTimeout(() => {
                          state.DB.cards = cards;
                          state.DB.wallets = wallets;
                        },50);
                        */

                      return;
                    }
                  
                        obj.splice(parseInt(Key),0,data.$update[key]);

                        state.DB.cards = state.DB.cards.map(c => c);
                        state.DB.wallets = state.DB.wallets.map(w => w);

                        return; 

                        var cards = state.DB.cards;
                        var wallets = state.DB.wallets;
                        state.DB.cards = []
                        state.DB.wallets = []
                        setTimeout(() => {
                          state.DB.cards = cards;
                          state.DB.wallets = wallets;
                        },50);

                      return;
                  }
                } 
                /*
                console.log('splice',{
                  Key: parseInt(Key),
                  key: key,
                  update: data.$update[key],
                  obj: obj
                });
                */
                return obj.splice(parseInt(Key),0,data.$update[key]) 
              }
              
              if ( Key == 'pages' && item == state.currentOffers ) { var pageLength = obj[key].length }
              
              obj[Key] = data.$update[key];


              if ( data.DB == 'wallets' && Key == 'cards' ) {
                    console.log('reset wallets / cards 254');
                    var wallets = state.DB.wallets;
                    var cards = state.DB.cards;
                    state.DB.cards = state.DB.cards.map(c => c);
                    state.DB.wallets = state.DB.wallets.map(w => w);
                    /*
                    setTimeout(() => {
                      state.DB.cards = cards;
                      console.log('cards.length 254',cards.length)
                      setTimeout(() => {
                        console.log('cards.length 254',cards.length)
                        console.log('wallets.length 254',wallets.length);
                        state.DB.wallets = wallets;   
                      },0);
                    },0);
                    */
              }

              /*
              console.log('data.DB',data.DB,'Key',Key);
              if ( data.DB == 'wallets' && Key == 'cards' ) {
                  console.log('here..');
                  obj[Key] = data.$update[key].map(card => {
                  var Card = state.DB.cards.find(c => c._id == card._id);
                  return Card;
                });
                console.log('updated wallets cards',obj);
              } else {
                
              }
              */
              /*
              console.log('obj[Key]',{
                obj,
                key,
                Key,
                value: data.$update[key]
              })
              */
              if ( Key == 'pages' && item == state.currentOffers ) { obj[key].length != pageLength && ( state.showCurrentOffers = true ); }
            } else {  
              console.log('obj[key]',{ obj, key });
              obj = obj[Key];
            } 
          });
      });
    },
    downloadBlob ( state , { fileName, blob } ) {
      state.item = { fileName, blob };
      state.component = 'download';
    },
    downloadCSV ( state, { fileName, csv } ) {
      console.log()
      state.item = {
        fileName,
        blob: URL.createObjectURL(new Blob([csv],{ type: 'text/csv' }))
      }
      state.component = 'download'
    }
  },
  actions: {
    getDB ({ state, commit }, DB ) {
      console.log('getDB',DB);
      WebSoc.SEND('search',{ DB, find: { client_id: state.client_id } },items => {
        console.log('getDB items',items);
        commit('addDB',{ DB, items });
      });
    },
    getWalletsAndCards ({ state, commit }) {
      ['wallets','cards'].forEach(DB => commit('resetDB',{ DB }));
      WebSoc.SEND('getWalletsAndCards',{ client_id: state.client_id },resp => {
        commit('addDB',{ DB: 'cards', items: resp.cards });
        commit('addDB',{ DB: 'wallets', items: resp.wallets });
      });
    },
    addHead ({ state, commit }, data ) {
      if ( document.head.querySelector('#'+data.id) ) return;
      var element = document.createElement(data.t);
          Object.keys(data).filter(k => k != 't').forEach(k => element.setAttribute(k,data[k]));
          document.head.appendChild(element);
    },
    getMessages ({ commit, state }) {
      WebSoc.SEND('search',{ DB: 'messages', find: { client_id: state.client_id, response: false }},messages => {
        commit('setDB',{ DB: 'messages', items: messages })
      })
    },
    makeDitems ({ commit, state }, dItem ) {
      return new Promise((resolve,reject) => {
        var customers = state.DB.customers;
        var items =  Object.keys(dItem || {}).reduce((p,customer_id) => {
          var item = dItem[customer_id];
          var customer = customers.find(c => c._id == customer_id) || { name: 'no name' };
          customer.qty = item.length;
          customer.customer_id = item._id;
          if ( item[0] ) { customer.date = format(item[0],'dd/MM/yy HH:mm'); }
          if ( item[1] ) { customer.date += ' - '+format(item[item.length  - 1],'dd/MM/yy HH:mm') }

          customer.start = item[item.length-1] || Infinity;
          p.push(customer);
          
          if ( customer._id ) return p;
          
          var customerName = state.customerNames[customer_id];

          if ( !customerName ) {
            state.customerNames[customer_id] = [ customer ];
            WebSoc.SEND('get',{ DB: state.client_id+'-customers', _id: customer_id, project: { name: 1 }},Customer => {
              if ( !Customer ) return p;
              state.customerNames[customer_id].name = Customer.name;
              state.customerNames[customer_id].forEach(customer => {
                commit('setObjValue',{ obj: customer, k: 'name', v: state.customerNames[customer_id].name })
                state.customerNames[customer_id] = { name: Customer.name, _id: customer_id }
              });
            });
            return p; 
          }
          if ( customerName.name ) {
            commit('setObjValue',{ obj: customer, k: 'name', v: customerName.name })
            return p;
          }
          
          if ( Array.isArray(customerName) ) {
            customerName.push(customer);
            return p;
          }
          return p;

      },[]).sort((a,b) => a.date < b.date ? 1 : -1);

        resolve(items);
      })
      
    },
    getCustomerName({ commit, state }, data ) {
      var { item, customer_id, complete } = data;
      var DB = state.DB.customers;
      var current = DB.find(c => c._id == customer_id);
      if ( current ) return commit('setCustomerName',{ item, name: current.name, complete });
      var current = state.customerNames.find(c => c && c._id == customer_id);
      if ( current ) return commit('setCustomerName',{ item, name: current.name, complete });
      var db = state.client_id+'-customers';
      WebSoc.SEND('get',{ DB: db, _id: customer_id, project: { name: 1 }},customer => {
        if ( !customer ) return;
        console.log('customer',customer);
        state.customerNames.push(customer);
        commit('setCustomerName',{ item, name: customer.name, complete });
      });
    },
    getName({ commit, state },customer_id) {
      var customer = state.DB.customers.find(c => c._id == customer_id);
      if ( customer ) return { name: customer.name, customer_id: customer._id }
      
    },
    initStore ({ commit, state, dispatch }) {

      //console.log('initStore');

      if ( window.webpackHotUpdate ) {

        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+location.host+'/'
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.copperhouse.club'+'/'
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.thatcafe.club'+'/'
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.thatcafe.club'+'/'
        //var URL = 'wss://api-v2.dev.memberstar.club/memberStar/dashboard/'+'my.copperhouse.club/'; //+location.host+'/';
        //var URL = 'wss://api-v2.dev.memberstar.club/memberStar/dashboard/'+location.host+'/';
        //var URL = 'wss://api-v2.dev.memberstar.club/memberStar/dashboard/'+'my.dev.memberstar.club'+'/';
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.dev.memberstar.club'+'/'
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.letsreset.club'+'/'
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.onegolf.memberstar.club'+'/'
        //var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.test.memberstar.club'+'/'
        var URL = 'ws://localhost:5555/memberStar/dashboard/'+'my.bar.memberstar.club'+'/'
      } else {

        if ( 2 > 1 || location.host.startsWith('my.dev.m') || location.host.startsWith('my.onegolf') || location.host.startsWith('my.letsrest') ) {
          var URL = 'wss://api-v2.dev.memberstar.club/memberStar/dashboard/'+location.host+'/';
        } else {
          var URL = 'wss://api-v2.memberstar.club/memberStar/dashboard/'+location.host+'/';
        }

      }
      console.log('URL',URL);
      //var URL = 'wss://api.memberstar.club/memberStar/dashboard/'+location.host+'/';

      var path = '';

      try {
        var hash = JSON.parse(localStorage.hash);
            hash && ( path = hash._id+'/'+hash.hash );
      } catch(e) {

      }

      if ( !hash ) {

      }

      WebSoc(URL+path,{
        onopen ( ws ) {
          //console.log('open',ws);
          var existAuth = localStorage.auth;
          console.log('existAuth',existAuth);
          if ( !existAuth ) return;

          existAuth = JSON.parse(existAuth);
          
          WebSoc.SEND({ t: 'reAuth', data: { reauth: localStorage.auth }},resp => {
              resp.username = existAuth.un;
              console.log('reAuth resp',resp);
              if ( resp.auth === true ) { commit('setValue',resp);  }

          });

        },
        onmessage (msg) {
          //console.log('onmessage',msg);
          typeof Service[msg.t] == 'function' ? Service[msg.t](msg.data) : console.log('no Service msg',msg);
          //msg.t == 'setClient' && dispatch('getDashboard');
        }
      })

      const Service = {
        authReset: () => {
          if ( !state.auth ) return;
          commit('setValue',{ authReset: true });
        },
        setClient: ( data ) => {
          var client = data.client;
              commit('setKeyValue',{ k: 'client_id', v: client._id })
              return commit('setKeyValue',{ k: 'client', v: client });


          //console.log('sentClient',client._id,client.title);
          Object.keys(client).forEach(k => {
            //k == '_id' && ( client[k] = '5d57d73e6b7852728852a4af' ); // Copper House
            //k == '_id' && console.log(k,client[k]);
            //k == '_id' && ( client[k] = "5f6f69b96783940464d0ae1c" ); // Chpper House v2
            k == '_id' && ( k = 'client_id', client[k] = client._id );
            commit('setKeyValue',{ k, v: client[k] });
          });
          dispatch('getDashboard');
          dispatch('getWalletsAndCards');

          document.querySelector('title').innerText = 'Dashboard '+client.siteTitle;
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = client.favicon;
          document.querySelector('head').appendChild(link);
        },
        setHash: ( hash ) => {
          commit('setValue',hash);
          try {
            localStorage.hash = JSON.stringify(hash);
            
          } catch(e) {

          }
        },
        adApproved: ({ ad_id, client_id }) => {
          commit('pushApprovedAd',{ ad_id, client_id });
        },
        dbWatch: ( watch ) => {
          console.log('dbWatch',watch); // CURRENTLY USES getDashboard q;
          if ( !watch ) return console.log('store.updateWatch !watch');
          if ( watch.DB != this.DB ) return console.log('watchDB watch.DB != this.DB',watch);
          if ( watch.$insert ) {
              console.log('watch.$insert',watch.DB,watch.$insert);
              commit('addDB',{ DB: watch.DB, items: [ watch.$insert ], top: true })
          } else if ( watch.$delete ) {
              commit('removeDB',{ DB: watch.DB, _id: watch._id })
          } else if ( watch.$update ) {
              commit('updateDB',watch);
          } 
        }
      }
    },
    Auth ({ commit, state, dispatch }, data ) {
      var { un, pw, complete } = data;
      WebSoc.SEND({ t: 'Auth', data: { un, pw: MD5.code(state.hash+MD5.code(pw)), dashboard: true }},resp => {
        if ( resp.auth === true ) { 
          commit('setValue',{ username: un }); 
          commit('setValue',resp); 
          commit('setKeyValue',{ k: 'username', v: un });
          dispatch('getDashboard');
          console.log('Auth resp',resp);
        }
        if ( resp.reauth ) { localStorage.auth = JSON.stringify({ un: un, auth: MD5.code(state.hash+MD5.code(pw)+resp.reauth) }) }
        complete(resp);
      })
    },
    newPassword ({ commit, state }, data ) {
      var { un, pw, email, mobile, complete, prettyPhone, msisdn, host } = data;
      WebSoc.SEND({ t: 'newPassword', data: { un, pw: MD5.code(pw), email, mobile, prettyPhone, msisdn, url: host } },resp => {
        
        if ( resp.auth == true ) { commit('setValue',{ username: un }); commit('setValue',resp) }
        
        complete(resp);
      })
    },
    deAuth ( { commit }) {
      WebSoc.SEND({ t: 'deAuth' },() => { commit('setValue',{ auth: false, menu: [] });; console.log('Logged Out'); })
    },
    logout ({ commit }) {
      WebSoc.SEND({ t: 'deAuth' },() => { commit('setValue',{ auth: false, menu: [] });; console.log('Logged Out'); })
    },
    getDashboard ({ commit, state }, client_id ) {
      //console.log('getDashboard',state.client_id);
      ['customers','users','ads','campaigns','messages','cards','wallets'].forEach(DB => commit('resetDB',{ DB }));
      WebSoc.SEND({ t: 'getDashboard', data: { client_id: state.client_id }},(resp) => {        
        
        //console.log('getDashboard resp',JSON.parse(JSON.stringify(resp)));
        resp.client && commit('setKeyValue',{ k: 'client', v: resp.client });
        Array.isArray(resp.customers) && commit('addDB',{ DB: 'customers', items: resp.customers });
        resp.wallets && commit('addDB',{ DB: 'wallets', items: resp.wallets });
        resp.cards && commit('addDB',{ DB: 'cards', items: resp.cards });
        resp.pages && commit('addDB',{ DB: 'pages', items: resp.pages });

        resp.users && commit('setDB',{ DB: 'users', items: resp.users });
        resp.ads && commit('setDB',{ DB: 'ads', items: resp.ads });
        
        if ( resp.campaigns ) {
          var currentOffers = resp.campaigns.find(c => c.currentOffers);
          currentOffers && commit('setValue',{ currentOffers });
          currentOffers && resp.campaigns.splice(resp.campaigns.indexOf(currentOffers),1);
        }
        
        resp.campaigns && commit('setDB',{ DB: 'campaigns', items: resp.campaigns });
        resp.customerCount && commit('setValue', resp );
        resp.userCount && commit('setValue', resp );
        resp.messages && commit('setDB',{ DB: 'messages', items: resp.messages });

        var $watch = resp.$watch;
        if ( !$watch ) return;   
        console.log('getDashboard $watch',$watch.DB,JSON.parse(JSON.stringify($watch)));     
        if ( $watch.$insert ) {

            commit('addDB',{ DB: $watch.DB, items: [ $watch.$insert ], top: true });
        } else if ( $watch.$delete ) {
            commit('removeDB',{ DB: $watch.DB, _id: $watch._id })
        } else if ( $watch.$update ) {
            //console.log('updateDB $watch',$watch);
            commit('updateDB',$watch);
        } 
      })
    },
    updateAd ({ commit, state }, update ) {

      commit('updateAd',update);

      WebSoc.SEND('updateCampaignAd',update,resp => {
        console.log('resp',resp);
      })
    },
    
    dbSearch ({ commit, state }, data ) {
      clearTimeout(this._searchCustomers);
      this._searchCustomers = setTimeout(() => {
             
              var search = Object.keys(data.search).reduce((p,field) => {

              var Field = data.search[field];
              if ( Field.value.length == 0 ) return p;
              
              if ( typeof Field.onsearch == 'function' ) { 
                  p[field] = Field.onsearch(Field.value);
              } else if ( Field.type == 'num' ) {
                var val = Field.value;
                var $lt = val.split('<')[1] && parseFloat(val.split('<')[1].split('>')[0]);
                var $gt = val.split('>')[1] && parseFloat(val.split('>')[1].split('<')[0]);
                if ( !isNaN($lt) ) { p[field] = { $lt: $lt } }
                if ( !isNaN($gt) ) { p[field] = p[field] || {}; p[field].$gt = $gt; }
                if ( !p[field]   ) { p[field] = { $eq: parseInt(val) } }
              } else {
                 p[field] = { $regex: Field.value, $options: 'i' }
              }
              return p;
          },{});

          WebSoc.SEND({ t: 'dbSearch', data: { DB: data.db, find: search, limit: data.limit }},items => {
            commit('resetDB',{ DB: data.db });
            commit('addDB',{ DB: data.db, items })
          })
      },300)      
    },
    stopDashboard () {

    },
    updateCampaign ({ commit, state }, data ) {
      console.log('data',data);
      if ( data.deleteCampaign ) {
        commit('removeDB',{ DB: 'campaigns', _id: data.deleteCampaign._id });
        WebSoc.SEND({ t: 'removeCampaign', data: { _id: data.deleteCampaign._id, client_id: data.deleteCampaign.client_id }});
      }
      if ( data.saveCampaign ) {
          var campaign = data.saveCampaign;
          
          if ( !campaign._id ) {
          
            //commit('addDB',{ DB: 'campaigns', items: [ campaign ], top: true });
            delete campaign._id;
            WebSoc.SEND({ t: 'saveCampaign', data: { campaign }},resp => {
                console.log('resp._id',resp._id);
                campaign._id = resp._id;
            })
        }
        if ( campaign._id ) {
            WebSoc.SEND('updateCampaign',{ _id: campaign._id, title: campaign.title },() => {
                console.log('updated');
            })
        }
      }

      if ( data.addPage ) {
        //console.log('addPage',data.addPage);
        commit('addPage', data );
        var campaign = data.campaign;
        return WebSoc.SEND('updateCampaign',{ _id: campaign._id, addPage: data.addPage },() => {
          //console.log('added Page');
        });
      }
      if ( data.removePage ) {
        var campaign = data.campaign;
        return WebSoc.SEND('updateCampaign',{ _id: campaign._id, client_id: campaign.client_id, removePage: data.removePage, removeFromCampaign: data.removeFromCampaign, removeFromCustomers: data.removeFromCustomers },() => {
          console.log('removed Page');
        })
      }
      if ( data.unRemovePage ) {
        return WebSoc.SEND('updateCampaign',{ _id: data.campaign._id, unRemovePage: data.unRemovePage },() => {
          console.log('unremovedPage');
        })
      }
      if ( data.permRemovePage ) {
        return WebSoc.SEND('updateCampaign',{ _id: data.campaign._id, permRemovePage: data.permRemovePage },() => {
          console.log('permRemoved Page')
        })
      }

    },

    updatePages ({ commit, state }, data ) {
      var campaign = data.campaign;
      var pages = data.pages;
      WebSoc.SEND('updateCampaign',{ _id: campaign._id, client_id: campaign.client_id, pages: pages },() => {
        //console.log('updated pages');
      })
    },
    removeCampaign ({ commit, state }, campaign ) {
      //console.log('removeCampaign',campaign._id);
      commit('removeDB',{ DB: 'campaigns', _id: campaign._id });
    },
    showStaffDetail ({ commit, state }, staff ) {
      staff.open = !staff.open;
      if ( !staff.open ) return;
      console.log('showStaffDetail',JSON.parse(JSON.stringify(staff)));
    },
    showCustomerDetail ( { commit, state }, customer ) {
      customer.open = !customer.open;
      if ( !customer.open ) return;
      customer.ads.forEach(ad => {
        if ( !ad.field ) {
          commit('setObjValue',{ obj: ad, k: 'field', v: ''});
          getAdTitle(ad.ad_id,title => {
            commit('setObjValue',{ obj: ad, k: 'field', v: title });
          })
        }
      })
      customer.redeemRewards = customer.redeemRewards || [];
      customer.redeemRewards.forEach(ad => {
        if ( !ad.staff ) {
          commit('setObjValue',{ obj: ad, k: 'staff', v: '' })
          getStaffName(ad.user_id,name => {
            commit('setObjValue',{ obj: ad, k: 'staff', v: name })
          })
        }
        if ( !ad.title ) {
          commit('setObjValue',{ obj: ad, k: 'title', v: '' })
          getAdTitle(ad.ad_id,title => {
            commit('setObjValue',{ obj: ad, k: 'title', v: title });
          })
        }
      })
    },        
  },
  modules: {
  }
})
